module.exports = __webpack_public_path__ + "static/media/rv-icon.9385c289.svg";